import React, { Component, ReactElement } from 'react'
import { observer, inject } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { Input } from 'antd'
import { OptionProps } from 'antd/lib/select'
import { AsyncProductInput } from '../../../../../components/GrInput/AsyncProductInput'
import { DiscountStore } from './DiscountStore'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  discountStore: DiscountStore
  filterOption: boolean | ((inputValue: string, option: ReactElement<OptionProps>) => boolean)
}

@inject('currentCompanyStore')
@observer
export class DiscountSpecificProducts extends Component<Props> {
  filterOption = (input: string, option: ReactElement<OptionProps>) => {
    const optionName = option.props.children

    if (optionName && typeof optionName === 'string') {
      const lowerCaseInput = input.toLowerCase().trim()

      return optionName.toLowerCase().indexOf(lowerCaseInput) >= 0
    }

    return true
  }

  render() {
    return (
      <>
        <div className='caption mb-2'>
          <strong>Choose products to include</strong>
        </div>

        <Input.Group style={{ display: 'flex', flexWrap: 'wrap' }} compact>
          <AsyncProductInput
            showSearch
            allowClear
            mode={'default'}
            style={{ width: '100%' }}
            placeholder='Search a product'
            debounceTime={400}
            dropdownMatchSelectWidth={false}
            onChange={(product) => {
              if (product.length === 1) {
                this.props.discountStore.addNewDiscountByProduct('include', product[0])
              }
            }}
            onSelect={() => this.setState({ selectedValue: undefined })}
            filterOption={this.props.filterOption}
            productIdsToHide={this.props.discountStore.getSelectedProductIds('include')}
            selectOptionClassName='discount-select-options'
          />
        </Input.Group>
      </>
    )
  }
}
